import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

@Component({
    selector: 'app-input-toggle-icon',
    templateUrl: './input-toggle-icon.component.html',
    styleUrls: ['./input-toggle-icon.component.scss'],
    standalone: false
})
export class InputToggleIconComponent implements OnInit {
  @Input() trueIcon: string = 'fa-circle-play';
  @Input() falseIcon: string = 'fa-circle-pause';
  @Input() trueText: string;
  @Input() falseText: string;
  @Input() control;
  @Input() tooltip;
  @Output() change = new EventEmitter<any>();

  ngOnInit(): void {}
  toggle($event: Event) {
    $event.stopPropagation();
    const value = !this?.control?.value;
    this.control.setValue(value);
    this.change.emit();
  }
}

export interface InputToggleIconConfig {
  trueText: string;
  falseText: string;
  trueIcon: string;
  falseIcon: string;
}
